import { Link, useLocation, useNavigate } from 'react-router-dom';
import React from 'react';
import OrderDetailsPage from './OrderDetailsPage';
import { LocationState } from '../utils/types';
import { useTranslation } from 'react-i18next';

const OrderDetails: React.FC = () => {
  const { t } = useTranslation(['translation', 'dynamic']);
  const location = useLocation();
  const navigate = useNavigate();

  // Get the order data from navigation state
  const state = location.state as LocationState;
  const order_token = state?.order_token;
  const requirements = state?.requirements;

  // If no order data, redirect back to form
  React.useEffect(() => {
    if (!order_token) {
      navigate('/order-form-page', { replace: true });
    }
  }, [order_token, navigate]);

  // #110 (S5): the guard on the design system (same copy, link and
  // redirect): the title row, then a warn notice with the search link
  if (!order_token) {
    return (
      <div className="xc-screen">
        <div className="xc-title-row">
          <h2 className="xc-title">{t('orderDetails.noOrder')}</h2>
        </div>
        <div className="xc-notice xc-notice--warn" role="alert">
          <p className="xc-notice__text">{t('orderDetails.searchOrder')}</p>
          <Link to="/order-form-page" className="xc-btn xc-btn--primary">
            {t('orderDetails.goSearch')}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Display the order (OrderDetailsPage owns the single container) */}
      <OrderDetailsPage
        order_token={order_token}
        requirements={requirements}
        offer_correlation_id={state.offer_correlation_id}
        offer_session={state.offer_session}
        products_to_return={[...state.products_to_return]}
        return_reasons={state.return_reasons}
        return_methods={state.return_methods}
        payment_methods={state.payment_methods}
        proof={state.proof}
        shop={state.shop}
        allow_exchanges={state.allow_exchanges}
        allow_exchange_more_expensive={state.allow_exchange_more_expensive}
        terms_and_conditions_url={state.terms_and_conditions_url}
        portal_details_mode={state.portal_details_mode}
        portal_details_max_length={state.portal_details_max_length}
        details_error={state.details_error}
        methods_draft_id={state.methods_draft_id}
        withdrawal_id={state.withdrawal_id}
        withdrawal_receipt={state.withdrawal_receipt}
      />
    </>
  );
};

export default OrderDetails;
